import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// 3rd party imports
import { DxPopupComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

// cc-imports
import { IconConstants } from 'cc-common';

// service imports
import { WorkflowVendorMissingBillsService } from '../../../_services/workflow-vendor-missing-bills.service';
import { ServerErrorService } from '../../../../_services/shared-services/server-error.service';

// model imports
import { KeyValueResultDto } from '../../../../_models/key-value-result-dto';
import { VendorMissingBillStatusUpdateParametersDto } from '../../../_models/workflow-vendor-missing-bills/vendor-missing-bill-status-update-parameters-dto';
import { VendorMissingBillsResultDto } from '../../../_models/workflow-vendor-missing-bills/vendor-missing-bills-result-dto';

// constant imports
import { MessageInterval } from '../../../../_constants/messages-intervals';

@Component({
    selector: 'app-update-vendor-missing-bill-status',
    templateUrl: './update-vendor-missing-bill-status.component.html',
    styleUrls: ['./update-vendor-missing-bill-status.component.scss']
})
export class UpdateVendorMissingBillStatusComponent implements OnInit {
    @ViewChild('updateStatusPopup', { static: false }) updateStatusPopup: DxPopupComponent;

    @Input() mode: string;
    @Input() workflowMissingBill: VendorMissingBillsResultDto;

    @Output() onClose = new EventEmitter<boolean>();

    missingBillStatusOptions: KeyValueResultDto[] = [];
    selectedMissingBillStatus: string;

    modesOptions: string[] = [];
    selectedMode: string;
    isResolved: boolean;

    visible = false;
    isUpdated = false;

    iconCancel: string = IconConstants.CANCEL;
    iconCheck: string = IconConstants.CHECK;

    constructor(
        private readonly workflowVendorMissingBillsService: WorkflowVendorMissingBillsService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
        this.setDefaultValues();
        this.getMissingBillStatusOptions();
    }

    onPopupShown(): void {
        this.visible = true;
        this.updateStatusPopup.instance.repaint();
    }

    onPopupClose(): void {
        this.closePopup();
    }

    onModeOptionValueChange(): void {
        this.isResolved = null;
        if (this.selectedMode === 'Resolved') {
            this.isResolved = true;
        } else if (this.selectedMode === 'UnResolved') {
            this.isResolved = false;
        }
    }

    onSave(): void {
        this.updateVendorMissingBill();
    }

    private getMissingBillStatusOptions(): void {
        const clearCache = true;
        this.workflowVendorMissingBillsService.getVendorMissingBillStatuses(clearCache).subscribe(
            (result: KeyValueResultDto[]) => {
                this.missingBillStatusOptions = result;

                const defaultStatus = this.missingBillStatusOptions.filter((d) => d.isDefault);
                if (defaultStatus.length > 0) {
                    this.selectedMissingBillStatus = defaultStatus[0].key;
                } else {
                    if (!!this.workflowMissingBill && !!this.workflowMissingBill.status) {
                        this.missingBillStatusOptions.forEach((status) => {
                            if (status.displayText === this.workflowMissingBill.status) {
                                this.selectedMissingBillStatus = status.key;
                            }
                        });
                    }
                }
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    private updateVendorMissingBill(): void {
        const baseParam: VendorMissingBillStatusUpdateParametersDto = new VendorMissingBillStatusUpdateParametersDto();
        if (this.isResolved !== null) {
            baseParam.isResolved = this.isResolved;
        }
        baseParam.statusCode = this.selectedMissingBillStatus;
        baseParam.workflowMissingBillQueueId = this.workflowMissingBill.workflowMissingBillQueueId;

        this.workflowVendorMissingBillsService.updateVendorMissingBill(baseParam).subscribe(
            () => {
                notify('Vendor missing bill updated successfully!!!', 'Success', MessageInterval.successMsgInterval);
                this.isUpdated = true;
                this.closePopup();
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    private setDefaultValues(): void {
        this.modesOptions = ['UnResolved', 'Resolved', 'All'];
        this.selectedMode = this.mode;

        this.isResolved = null;
        if (this.selectedMode === 'Resolved') {
            this.isResolved = true;
        } else if (this.selectedMode === 'UnResolved') {
            this.isResolved = false;
        }
    }

    private closePopup(): void {
        this.visible = false;
        this.onClose.emit(this.isUpdated);
    }
}
